var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 40,
    viewBox: "0 0 195 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2169_167248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2676 23.1677H54.4174C54.5228 25.521 57.2107 26.7516 59.9258 26.7516C62.1706 26.7516 64.9111 25.9155 64.9111 24.1353C64.9111 19.8448 50.8141 22.3571 50.8141 15.6348C50.8141 12.3394 54.4428 10.4297 59.4027 10.4297C64.6496 10.4297 68.3817 12.6534 68.5125 16.5494H64.4134C64.2826 14.3001 61.8544 13.1755 59.35 13.1755C57.1053 13.1755 54.8605 13.8821 54.8605 15.4503C54.8605 19.4778 69.061 17.0715 69.061 24.0293C69.061 27.5602 64.9365 29.5739 59.8458 29.5739C54.4936 29.5739 50.3183 27.2207 50.2656 23.1657L50.2676 23.1677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3984 10.8228V10.7188H72.8879L76.3077 15.9768L78.0313 18.8542H78.371L80.0945 15.9768L83.5143 10.7188H88.0038V10.8228L80.1726 21.9651V29.2879H76.2316V21.9906L68.4004 10.8228H68.3984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4578 10.7188H96.4431L102.473 22.0181L104.352 25.81H105.449V10.7188H109.156V29.2899H102.238L96.2596 17.9906L94.3799 14.1986H93.2829V29.2899H89.5508V12.603C89.5508 11.5038 90.3608 10.7207 91.4559 10.7207L91.4578 10.7188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.419 13.7001H111.109V10.7188H129.696V13.7001H122.36V29.2879H118.419V13.7001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.633 22.2006V10.7188H135.574V22.3066C135.574 25.4194 138.211 26.6226 141.004 26.6226C143.797 26.6226 146.434 25.4194 146.434 22.3066V10.7188H150.375V22.2006C150.375 25.4705 148.078 29.5765 141.004 29.5765C133.93 29.5765 131.633 25.4705 131.633 22.2006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.864 10.7188H163.138C167.681 10.7188 170.448 12.7855 170.448 16.2889C170.448 18.9837 168.725 20.9189 165.645 21.5725L167.159 23.4822L171.596 29.2879H166.898L161.495 21.8336H156.875V29.2879H152.934V12.601C152.934 11.5019 153.744 10.7188 154.866 10.7188H154.864ZM163.088 19.0622C165.307 19.0622 166.299 17.9906 166.299 16.2634C166.299 14.5362 165.045 13.5686 162.773 13.5686H156.875V19.0622H163.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.014 10.7188H186.62L195 29.2899H190.692L188.263 23.6923H178.291L175.863 29.2899H171.633L180.013 10.7188H180.014ZM187.036 20.8679L185.339 16.9445L183.903 13.4921H182.675L181.238 16.9445L179.542 20.8679H187.034H187.036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.877 28.208C25.877 28.7987 26.1112 29.3346 26.4879 29.7291H26.486L32.3262 35.6035L35.4103 32.5024L29.6208 26.6829C29.6052 26.6672 29.5896 26.6515 29.5739 26.6358L29.5681 26.63C29.1758 26.2492 28.6429 26.0156 28.0553 26.0156C26.851 26.0156 25.875 26.997 25.875 28.208H25.877Z",
    fill: "url(#paint0_linear_2169_167248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9181 11.8017C13.9181 11.211 13.6839 10.6751 13.3052 10.2806H13.3071L7.4669 4.40625L4.38281 7.50733L10.1723 13.3287C10.1879 13.3444 10.2016 13.3601 10.2172 13.3739L10.2231 13.3798C10.6154 13.7605 11.1483 13.9941 11.7358 13.9941C12.9402 13.9941 13.9161 13.0127 13.9161 11.8017H13.9181Z",
    fill: "url(#paint1_linear_2169_167248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0573 13.9687C28.6448 13.9687 29.1777 13.7332 29.57 13.3544H29.572L35.4122 7.48389L32.3282 4.38281L26.5406 10.2042C26.525 10.2199 26.5094 10.2356 26.4938 10.2513L26.4879 10.2572C26.1092 10.6517 25.875 11.1875 25.875 11.7783C25.875 12.9893 26.851 13.9706 28.0553 13.9706L28.0573 13.9687Z",
    fill: "url(#paint2_linear_2169_167248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7339 26.0156C11.1463 26.0156 10.6134 26.2511 10.2211 26.6319H10.2191L4.37891 32.5024L7.46299 35.6035L13.2525 29.7821C13.2681 29.7664 13.2837 29.7526 13.2974 29.7369L13.3032 29.731C13.6819 29.3365 13.9161 28.8007 13.9161 28.2099C13.9161 26.9989 12.9402 26.0176 11.7358 26.0176L11.7339 26.0156Z",
    fill: "url(#paint3_linear_2169_167248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.714 0V12.0393C17.714 15.2188 15.1413 17.8037 11.9811 17.8037H0V22.1766H11.9811C14.6748 22.1766 17.2065 21.1227 19.1116 19.2071C21.0167 17.2915 22.0649 14.7458 22.0649 12.0373V0",
    fill: "url(#paint4_linear_2169_167248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0638 39.997V27.946C22.0638 24.7664 24.6365 22.1796 27.7986 22.1796H39.7817V17.8047H27.7986C25.1049 17.8047 22.5733 18.8587 20.6681 20.7743C18.763 22.6899 17.7148 25.2355 17.7148 27.944V39.9951",
    fill: "url(#paint5_linear_2169_167248)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2169_167248",
    x1: -0.564184,
    y1: 30.8086,
    x2: 35.1058,
    y2: 30.8086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2169_167248",
    x1: 4.61119,
    y1: 9.20115,
    x2: 40.2792,
    y2: 9.20115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2169_167248",
    x1: -11.9831,
    y1: 9.17575,
    x2: 73.0791,
    y2: 9.17575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2169_167248",
    x1: -33.4694,
    y1: 30.8086,
    x2: 51.5927,
    y2: 30.8086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2169_167248",
    x1: -5.83438,
    y1: 11.0893,
    x2: 53.7099,
    y2: 11.0893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2169_167248",
    x1: -13.858,
    y1: 28.9018,
    x2: 45.4521,
    y2: 28.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2E8DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#594CF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B33EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2169_167248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cf87d1865962f302ecdd12157c8f4f96.svg";
export { ForwardRef as ReactComponent };